/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerPortalDto
 */
export interface CustomerPortalDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerPortalDto
     */
    returnUrl: string;
}

/**
 * Check if a given object implements the CustomerPortalDto interface.
 */
export function instanceOfCustomerPortalDto(value: object): value is CustomerPortalDto {
    if (!('returnUrl' in value) || value['returnUrl'] === undefined) return false;
    return true;
}

export function CustomerPortalDtoFromJSON(json: any): CustomerPortalDto {
    return CustomerPortalDtoFromJSONTyped(json, false);
}

export function CustomerPortalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerPortalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'returnUrl': json['returnUrl'],
    };
}

export function CustomerPortalDtoToJSON(json: any): CustomerPortalDto {
    return CustomerPortalDtoToJSONTyped(json, false);
}

export function CustomerPortalDtoToJSONTyped(value?: CustomerPortalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returnUrl': value['returnUrl'],
    };
}

